/**
 * ЭТАП 1 · Шаг 3 — SSR-shim для react-scroll-up.
 *
 * Пакет — CJS c __esModule:true и единственным export default (компонент).
 * Под dev-SSR Vite/Node интероп даёт ДВОЙНУЮ обёртку: `import * as ns` →
 * ns.default = весь объект exports ({__esModule, default: fn}), а сам компонент
 * лежит в ns.default.default. Прямой default-импорт тоже отдаёт объект →
 * <ScrollToTop/> === object ("Element type is invalid: got object").
 *
 * Устойчиво распутываем цепочку `.default` до первой function.
 * alias `^react-scroll-up$` → этот файл (см. vite.start.config.mts).
 */
// @ts-ignore -- у пакета нет типов на подпуть index.js
import * as ns from 'react-scroll-up/index.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let Comp: any = ns;
for (let i = 0; i < 4 && Comp && typeof Comp !== 'function'; i++) {
  Comp = Comp.default;
}

export default Comp;
